import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { ApprovalFlowStages, stageInput } from './approval-flow-stages.model';

export const loadApprovalFlowStagess = createAction(
  '[ApprovalFlowStages/API] Load ApprovalFlowStagess',
  props<{ approvalFlowStagess: ApprovalFlowStages[] }>()
);

export const addApprovalFlowStages = createAction(
  '[ApprovalFlowStages/API] Add ApprovalFlowStages',
  props<{ approvalFlowStages: ApprovalFlowStages }>()
);

export const upsertApprovalFlowStages = createAction(
  '[ApprovalFlowStages/API] Upsert ApprovalFlowStages',
  props<{ approvalFlowStages: ApprovalFlowStages }>()
);

export const addApprovalFlowStagess = createAction(
  '[ApprovalFlowStages/API] Add ApprovalFlowStagess',
  props<{ approvalFlowStagess: ApprovalFlowStages[] }>()
);

export const upsertApprovalFlowStagess = createAction(
  '[ApprovalFlowStages/API] Upsert ApprovalFlowStagess',
  props<{ approvalFlowStagess: ApprovalFlowStages[] }>()
);

export const updateApprovalFlowStages = createAction(
  '[ApprovalFlowStages/API] Update ApprovalFlowStages',
  props<{ approvalFlowStages: Update<ApprovalFlowStages> }>()
);

export const updateApprovalFlowStagess = createAction(
  '[ApprovalFlowStages/API] Update ApprovalFlowStagess',
  props<{ approvalFlowStagess: Update<ApprovalFlowStages>[] }>()
);

export const deleteApprovalFlowStages = createAction(
  '[ApprovalFlowStages/API] Delete ApprovalFlowStages',
  props<{ id: string }>()
);

export const deleteApprovalFlowStagess = createAction(
  '[ApprovalFlowStages/API] Delete ApprovalFlowStagess',
  props<{ ids: string[] }>()
);

export const clearApprovalFlowStagess = createAction(
  '[ApprovalFlowStages/API] Clear ApprovalFlowStagess'
);



//CUSTOM
export const createApprovalFlowStagesMutation = createAction(
  '[ApprovalFlowStages/API] create Approval Flow Stages Mutation',
  props<{ stage?: stageInput }>()
);

export const updateApprovalFlowStagesMutation = createAction(
  '[ApprovalFlowStages/API] update Approval Flow Stages Mutation',
  props<{ stage?: stageInput }>()
);

export const createApprovalFlowStageSuccessorMutation = createAction(
  '[ApprovalFlowStages/API] create successor Approval Flow Stages Mutation',
  props<{ successor?: { successorCurrentStage?: string; successorStage?: string; } }>()
);

export const removeApprovalFlowStageSuccessorMutation = createAction(
  '[ApprovalFlowStages/API] remove successor Approval Flow Stages Mutation',
  props<{ successorUniqueId: string; }>()
);

export const updateApprovalFlowStageSuccessorMutation = createAction(
  '[ApprovalFlowStages/API] update successor Approval Flow Stages Mutation',
  props<{ successor?: { successorCurrentStage?: string; successorStage?: string; successorUniqueId: string; } }>()
);

export const getApprovalFlowStages = createAction(
  '[ApprovalFlowStages/API] get Approval Flow Stages',
   props<{flowUniqueId?:string}> ()
);


export const removeApprovalFlowStagesMutation = createAction(
  '[ApprovalFlowStages/API] delete Approval Flow Stages Mutation',
   props<{stageUniqueId?:string,id?:string}> ()
);
